module.exports = __webpack_public_path__ + "img/ep-planche-wavy.5344a749.jpg";